import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { ACCOUNTS_URI, HOST, VERIFYCODE_URI } from 'variables';

// Define thunk action creators
const VERIFY_ACC_URL = HOST + ACCOUNTS_URI + VERIFYCODE_URI;

export const verifyAccount = createAsyncThunk('account/verifyAccount', async ({ code, user_name }) => {
  const response = await axios.get(VERIFY_ACC_URL, { params: { code, user_name } });

  const data = await response.data;

  if (data) {
    sessionStorage.removeItem('username-to-be-reg');
  }
});

const account = createSlice({
  name: 'account',
  initialState: {
    loading: true,
    account: null,
    error: null,
    success: false,
    isCreating: false,
    isCreated: false,
    isError: false,
    errorMessage: '',
    isVerifying: false,
    isVerified: false,
    isDeleting: false,
    isDeleted: false
  },
  reducers: {
    resetCreateStatus: (state) => {
      state.isCreated = false;
      state.isError = false;
      state.errorMessage = '';
      state.isCreating = false;
    },
    resetVerificationStatus: (state) => {
      state.isVerifying = false;
      state.isVerified = false;
      state.isError = false;
      state.errorMessage = '';
    },
    resetAccount: () => null,
    newAccount: {
      reducer: (state, action) => {
        state.account = action.payload;
        state.loading = false;
        state.error = null;
        state.success = true;
      },
      prepare: (event) => ({
        payload: {
          name: '',
          email: ''
        }
      })
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyAccount.fulfilled, (state, action) => {
        state.isVerified = true;
        state.isError = null;
        state.isVerifying = false;
      })
      .addCase(verifyAccount.pending, (state, action) => {
        state.isVerified = false;
        state.isVerifying = true;
        state.isError = false;
      })
      .addCase(verifyAccount.rejected, (state, action) => {
        state.isVerified = false;
        state.isVerifying = false;
        state.errorMessage = action.error.message;
        state.isError = true;
      });
    //   .addCase(createAccount.fulfilled, (state, action) => {
    //     state.isCreating = false;
    //     state.isCreated = true;
    //     state.isError = false;
    //     state.errorMessage = '';
    //     state.account = action.payload;
    //   })
    //   .addCase(createAccount.pending, (state, action) => {
    //     state.isCreating = true;
    //     state.isCreated = false;
    //     state.isError = false;
    //     state.errorMessage = '';
    //   })
    //   .addCase(createAccount.rejected, (state, action) => {
    //     state.isCreating = false;
    //     state.isCreated = false;
    //     state.isError = true;
    //     state.errorMessage = action.error.message;
    //   })
    //   .addCase(updateAccount.fulfilled, (state, action) => {
    //     state.isVerifying = false;
    //     state.isVerified = true;
    //     state.isError = false;
    //     state.errorMessage = '';
    //   })
    //   .addCase(updateAccount.pending, (state) => {
    //     state.isVerifying = true;
    //     state.isVerified = false;
    //   })
    //   .addCase(updateAccount.rejected, (state, action) => {
    //     state.isVerifying = false;
    //     state.isVerified = false;
    //     state.isError = true;
    //     state.errorMessage = action.error.message;
    //   });
  }
});

export const { newAccount, resetAccount, resetCreateStatus, resetVerificationStatus } = account.actions;

export const selectAccount = (state) => state.account.account;
export const selectIsCreating = (state) => state.account.isCreating;
export const selectIsCreated = (state) => state.account.isCreated;
export const selectIsError = (state) => state.account.isError;
export const selectErrorMessage = (state) => state.account.errorMessage;

export default account.reducer;

// [verifyAccount.fulfilled]: (state, action) => action.payload,
//     [updateAccount.fulfilled]: (state, action) => action.payload
